import React, { Children, useContext, useEffect, useRef, useState } from "react";
import { appUrl, baseUrl } from '../../config.js'
import { NavLink, useOutletContext, useNavigate, useParams, Link } from 'react-router-dom';
import SubirComprobante from './SubirComprobante.jsx';
import Perfil from "../Cuenta/Perfil.jsx";
import {Elements, PaymentElement, useStripe, useElements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import useToken from '../../useToken';
import Calendar from "react-calendar";
import 'react-calendar/dist/Calendar.css';

import { formatoFecha, formatoFechaTxt, estatus, imgEstatus, formatoNumero } from '../../almacen.js';
import { calculaDias, calculaPrecio as calculaPrecioUtil, calculaFechaF } from '../reservaUtils';
import Cargando from '../../img/Cargando.gif';
import Tarjeta from '../../img/Tarjeta.png';
import Transferencia from '../../img/Transferencia.png';
import Copiar from '../../img/Copiar.png';
import './Reservar.css';
import Modal from "../Modal/Modal.js";
import RatingListModal, { StarsRow } from '../RatingComponent/RatingListModal';

const stripePromise = loadStripe('pk_test_mvWe2DA5Ez2FX37mx2FIaMd2003sG0WdPw');

const Reservar = ({user, setModalLogin})=>{
    
    const {token} = useToken();

    const { id } = useParams();
    const navigate = useNavigate();
    const [config, setConfig] = useState(localStorage.getItem('config') ? JSON.parse(localStorage.getItem('config')) : {
        idioma : 'es',
        sistema : 'internacional',
      })

    const [archivos, setArchivos] = useState([]);
    const [perfiles, setPerfiles] = useState([]);
    const [perfil, setPerfil] = useState({});
    const [modal, setModal] = useState(false);
    const [modalEditar, setModalEditar] = useState('');
    const [modalTransferencia, setModalTransferencia] = useState(false);
    const [modalPerfil, setModalPerfil] = useState(false);
    const [reserva, setReserva] = useState([]);
    const [publicacion, setPublicacion] = useState({TypeTime:[]});
    const [calendario, setCalendario] = useState(true);
    const [calendarioF, setCalendarioF] = useState(false);
    const hoy = new Date();
    const auxMax = new Date();
    const maxDate = new Date(auxMax.setFullYear(auxMax.getFullYear() + 1));
    const [fechaI, setFechaI] = useState(new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate()));
    const [fechaF, setFechaF] = useState();
    const [fechaMinima, setFechaMinima] = useState(new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate()));
    const [dias, setDias] = useState();
    const [costo, setCosto] = useState();
    const [pagar, setPagar] = useState(false);
    const [clientSecret, setClientSecret] = useState('');
    const [orden, setOrden] = useState("");
    const [periodo, setPeriodo] = useState("3");
    const [espacios, setEspacios] = useState(1);
    const [error, setError] = useState("");
    const [cargando, setCargando] = useState(false);
    const [metodo, setMetodo] = useState('Transferencia');
    const [progreso, setProgreso] = useState(0);
    const [editable, setEditable] = useState(false);
    const [reservarFixed, setReservarFixed] = useState(false);
    // Ratings state
    const [showRatingsModal, setShowRatingsModal] = useState(false);
    const [avgRating, setAvgRating] = useState(null);
    const [ratingsCount, setRatingsCount] = useState(0);
    
    const refEspacios = useRef();
    const refDias = useRef();
    const divMedidas = useRef();
    const refCalendario = useRef();
    const refCalendarioF = useRef();
    const refPhone = useRef();

    const lblsTiempo = {
        "1" : "Días",
        "2" : "Semanas",
        "3" : "Meses",
        "4" : "Años",
    }

    useEffect(()=>{
        if(token)
            getData();
    },[id, token])

    // Fetch ratings for the warehouse
    useEffect(() => {
        if (reserva?.idPost && token) {
            fetch(baseUrl+`Post/ratings/${reserva.idPost}/avg`, {
                headers: { 'Authorization': `Bearer ${token}` }
            })
            .then(res => res.json())
            .then(data => {
                setAvgRating(data.avg*1 || null);
                setRatingsCount(data.count || 0);
            });
        }
    }, [reserva?.idPost, token]);

    useEffect(()=>{
        const aux = new Date(fechaI.getTime());
        if(periodo == "2")
            aux.setDate(aux.getDate()+7);
        else if(periodo == "3"){
            aux.setDate(aux.getDate()+29);
        }
        else if(periodo == "4"){
            aux.setFullYear(aux.getFullYear()+1);
            aux.setDate(aux.getDate()-1);
        }
        setFechaMinima(aux);
    }, [periodo, fechaI])
    

    const getData = async ()=>{
        const result1 = await fetch(baseUrl+"Booking/"+id, {
            headers:{
                'Authorization': `Bearer ${token}`,
            }
        })
        .then(async response=>{
            const json = await response.json();
            if(!response.ok || !json?.data){
                throw new Error(json?.error || json?.message || "No se pudo cargar la reservación.");
            }
            return json;
        })
        .catch(error=>{
            console.error(error);
            setError(error.message || "No se pudo cargar la reservación.");
            return null;
        })

        if(!result1?.data){
            setReserva({TypeTime:[]});
            return;
        }

        const reservaData = {...result1.data};
        if(!reservaData.rfc){
            // obtener el rfc del primer perfil y asignarlo.
            reservaData.rfc = reservaData.profiles?.[0]?.rfc || "";
        }
        setReserva(reservaData);
        setPerfiles(reservaData.profiles || []);
        setArchivos(reservaData.reqDocuments || []);
        setPeriodo(reservaData.period?.toString() || "3");
    }
    
    useEffect(()=>{
        if(reserva?.idBooking){

            setFechaI(new Date(reserva?.startDate.split("T")[0].split("-")));
            setFechaF(new Date(reserva?.endDate.split("T")[0].split("-")));
            setDias(reserva?.time);
            setPagar(!reserva?.inmediate && reserva?.inmediate != 0 && reserva.status != 'CreatedSpacesPending');
            if(reserva?.status == 'Approved' || reserva?.status == 'Booked' || reserva?.status == 'Partial' || reserva?.status == 'Waiting' || reserva?.status == 'WaitingSpaces'){
                setEditable(false);
            }
            else{
                setEditable(true);
            }
            if(reserva?.status == 'Booked'){
                setCosto(reserva?.price*1);
            }
            setEspacios(reserva?.spaces);
            if(reserva?.status == 'Partial'){
                setProgreso(1)
            }
            else if(reserva?.status == 'Approved' || reserva?.status == 'ConfirmTransfer'){
                setProgreso(2)
            }
            else if(reserva?.status == 'Waiting' || reserva?.status == 'WaitingSpaces'){
                setProgreso(1)
            }
            else if(reserva?.status == 'Booked'){
                setProgreso(3)
            }
        }
    }, [reserva])

    useEffect(()=>{
        if(reserva?.status!= "Booked" && fechaF && fechaI){
            // const intervalo = Math.ceil((fechaF.getTime() - fechaI.getTime())/86400000)+1;
            // setDias(intervalo)
            
            let total = calculaPrecio();

            total = Math.round(total*100)/100;
            console.log(total, espacios)
            setCosto(total*espacios);
        }
    }, [fechaI, fechaF])
    
    useEffect(()=>{
        if(reserva?.status!= "Booked" && fechaF && fechaI){
            let total = calculaPrecio();
            console.log(total);
            total = Math.round(total*100)/100;
            console.log(total, espacios)
            setCosto(total*espacios);
        }
    }, [espacios])

    useEffect(()=>{
        if(orden)
            verifica();
    },[orden])
    function verifica(){
        fetch(baseUrl+"Booking/validate/"+orden, {
			headers:{
				'Authorization': `Bearer ${token}`,
			}
		})
        .then(response=> response.json())
        .then(json=>{
            if(json["status"] == "COMPLETED"){
                navigate("/completado/"+id);
            }
            else{
                setTimeout(function(){
                    verifica();
                }, 5000)
            }
            //si es true ya quedó y redirigimos, si no, llamamos un settimeout
        });
    }

    const copiar = (valor)=>{
        navigator.clipboard.writeText(valor).then(() => {
            console.log('Valor copiado al portapapeles:', valor);
        }).catch(err => {
            console.error('Error al copiar:', err);
        });
    }

    const copiarConAnimacion = (valor, elemento) => {
        copiar(valor);
        elemento.classList.add('copied');
        setTimeout(() => elemento.classList.remove('copied'), 2000);
    }

    function calculaPrecio(){
        return calculaPrecioUtil({ dias, periodo, typeTime: reserva?.TypeTime });
    }

    const reservar = () =>{
        setCargando(true);
        if(espacios <= 0){
            setError("Selecciona la cantidad de espacios");
            setCargando(false);
            return false;
        }
        if(!fechaI || !fechaF){
            setError("Elige un intervalo de fechas correcto");
            setCargando(false);
            return false;
        }

        if(!reserva?.rfc){
            // asignar el rfc del select activo:

        }

        const data = {
            idBooking : id,
            startDate : fechaI || '',
            endDate : fechaF || '',
            spaces : espacios || '',
            price : costo || '',
            method : metodo == 'Tarjeta' ? 'card' : 'customer_balance',
            phone : reserva?.phone || '',
            rfc : reserva?.rfc || '',
        }
        fetch(baseUrl+"Booking", {
			method: "put",
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json',
				'Authorization': `Bearer ${token}`,
			},
			body: JSON.stringify(data),
		})
		.then(response=>response.json())
		.then(json=>{
			console.log(json);
            setPagar(true);
            setProgreso(1);
            setClientSecret(json?.clientSecret);
		})
		.catch(error=>{
            setCargando(false);
			console.error(error);
		})
    }

    const validar = () =>{
        if(!reserva?.phone || !refPhone.current.reportValidity()){
            setError("Ingresa un número de teléfono válido para continuar");
            setTimeout(()=>{
                setError("");
            }, 5000)
            return false;
        }
        if(espacios <= 0){
            setError("Selecciona la cantidad de espacios");
            setCargando(false);
            return false;
        }
        if(!fechaI || !fechaF){
            setError("Elige un intervalo de fechas correcto");
            setCargando(false);
            return false;
        }
        return true
    }

    const solicitarReservacion = () =>{
        
        setCargando(true);
        const data = {
            idBooking : id,
            startDate : fechaI || '',
            endDate : fechaF || '',
            spaces : espacios || '',
            price : costo || '',
            phone : reserva?.phone || '',
            rfc : reserva?.rfc || '',
        }
        fetch(baseUrl+"AskBooking/"+id, {
			method: "put",
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json',
				'Authorization': `Bearer ${token}`,
			},
			body: JSON.stringify(data),
		})
		.then(response=>response.json())
		.then(json=>{
			console.log(json);
            setCargando(false);
            reserva.status= reserva?.status == 'CreatedSpacesPending' ? 'WaitingSpaces' : 'Waiting';
            setReserva({...reserva});
            setPagar(true);
            setProgreso(1);
		})
		.catch(error=>{
            setCargando(false);
			console.error(error);
		})
    }

    const cambiaFechaF = (e) => {
        const valor = e ? e.target.value * 1 : refDias.current.value * 1;
        if (valor === 0) {
            setDias('');
            setFechaF('');
            return false;
        }
        const nuevaFechaF = calculaFechaF({ fechaI, dias: valor, periodo });
        setFechaF(nuevaFechaF);
    }

    const ConfirmTransfer = async () =>{
        setCargando(true);
        const data = {
            idBooking : id,
        }
        fetch(baseUrl+"Booking/ConfirmTransfer", {
            method: "put",
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        })
        .then(response=>response.json())
        .then(json=>{
            console.log(json);
            setCargando(false);
            setModalTransferencia(false);
            if(json?.success){
                reserva.status = 'ConfirmTransfer';
                setReserva({...reserva});
                setProgreso(3);
            }
        })
        .catch(error=>{
            setCargando(false);
            console.error(error);
        })
    }

    return(
        <>
            {modalPerfil &&
                <Modal className={'modalPerfil persona'} setModal={setModalPerfil} titulo={'Registrar Perfil'}>
                    <Perfil perfil={perfil} setPerfiles={setPerfiles} setModal={setModalPerfil} archivos={archivos} setArchivos={setArchivos}/>
                </Modal>
            }
            {modalTransferencia &&
                <Modal className={'modalTransferencia'} setModal={setModalTransferencia} titulo={'Confirmar transferencia'}>
                    <div className="confirmarTransferencia">
                        <div className="transferencia-head">
                            <h4>Comprobante de transferencia <span>(opcional)</span></h4>
                            <p>Adjunta tu comprobante para acelerar la aprobación de tu pago.</p>
                        </div>
                        <SubirComprobante reserva={reserva}/>
                    </div>
                    <div className="botones transferencia-actions">
                        <button type="button" className="btn btn--ghost" onClick={() => setModalTransferencia(false)}>Cancelar</button>
                        <button type="button" className="btn" onClick={ConfirmTransfer}>Confirmar</button>
                    </div>
                </Modal>
            }
            {modalEditar &&
                <Modal className={'modalEditarReserva'} setModal={setModalEditar} titulo={'Editar reservación'}>
                    <div className="editarReserva-wrap">
                        <div className="editarReserva">
                            {modalEditar !== '' &&
                                <form onSubmit={(e) => e.preventDefault()} className="edit-resv-form">
                                    <div className="edit-resv-fields">
                                        <label className="edit-resv-field">
                                            <span>Cantidad de espacios</span>
                                            <input type="number" ref={refEspacios} min={1} value={espacios} onChange={(e) => {
                                                setEspacios(Number(e.target.value));
                                            }} max={reserva?.assignedSpaces}/>
                                        </label>
                                        <label className="edit-resv-field">
                                            <span>{lblsTiempo[periodo] + (periodo === "3" ? '*' : '')}</span>
                                            <input type="number" ref={refDias} min={1} value={dias ? Math.round(dias * 1000) / 1000 : ''} onChange={(e) => {
                                                setDias(Number(e.target.value));
                                                setFechaF(calculaFechaF({ fechaI, dias: Number(e.target.value), periodo }));
                                            }} step={'any'}/>
                                        </label>
                                        <label className="edit-resv-field" onClick={() => {
                                            setCalendario(true);
                                            setCalendarioF(false);
                                        }}>
                                            <span>Desde</span>
                                            <input type="text" value={formatoFecha(fechaI)} readOnly={true}/>
                                        </label>
                                        <label className="edit-resv-field" onClick={() => {
                                            setCalendario(false);
                                            setCalendarioF(true);
                                        }}>
                                            <span>Hasta</span>
                                            <input type="text" value={formatoFecha(fechaF)} readOnly={true}/>
                                        </label>
                                    </div>

                                    {(calendario || reservarFixed) &&
                                        <div ref={refCalendario} className="edit-resv-cal">
                                            <h4>Selecciona el rango de fechas</h4>
                                            <Calendar className="edit-resv-calendar"
                                                defaultActiveStartDate={fechaI}
                                                value={[fechaI, fechaF]}
                                                onChange={(value) => {
                                                    setFechaI(value[0]);
                                                    if (fechaF > value[0]) {
                                                        if (!reservarFixed) {
                                                            return false;
                                                        }
                                                    } else {
                                                        setFechaF(value[0]);
                                                    }
                                                    if (value[1]) {
                                                        setFechaF(new Date(value[1].getFullYear(), value[1].getMonth(), value[1].getDate()));
                                                    }
                                                    setDias(calculaDias({ fechaI: value[0], fechaF: value[1] || fechaF, periodo }));
                                                }}
                                                selectRange={true}
                                                minDate={hoy}
                                                maxDate={maxDate}/>
                                        </div>
                                    }
                                    {calendarioF &&
                                        <div ref={refCalendarioF} className="edit-resv-cal">
                                            <h4>Fecha final</h4>
                                            <Calendar className="edit-resv-calendar"
                                                defaultActiveStartDate={fechaF || fechaMinima}
                                                value={[fechaI, fechaF]}
                                                tileDisabled={({ date }) => date < fechaMinima}
                                                onChange={(value) => {
                                                    setFechaF(value);
                                                    setCalendario(true)
                                                    setCalendarioF(false);
                                                    setDias(calculaDias({ fechaI, fechaF: value, periodo }));
                                                }}
                                                minDate={hoy}/>
                                        </div>
                                    }
                                </form>
                            }
                        </div>
                        <div className="botones edit-resv-actions">
                            <button type="button" className="btn btn--ghost" onClick={() => setModalEditar(false)}>Cancelar</button>
                            <button type="button" className="btn" onClick={() => setModalEditar(false)}>Actualizar</button>
                        </div>
                    </div>
                </Modal>
            }
            <div className={"booking" + (!reserva?.idBooking ? " placeholder" : "")}>
                {error &&
                    <div className="floatingError reserva-alerta" role="alert" aria-live="assertive">
                        <span className="reserva-alerta__icon">!</span>
                        <div className="reserva-alerta__content">
                            <strong>No pudimos continuar</strong>
                            <span>{error}</span>
                        </div>
                        <button
                            type="button"
                            className="reserva-alerta__close"
                            onClick={()=>setError("")}
                            aria-label="Cerrar mensaje"
                        >
                            ×
                        </button>
                    </div>
                }
                {reserva?.status != 'Canceled' &&
                    <Progreso progreso={progreso} inmediate={reserva?.inmediate} status={reserva?.status}/>
                }
                {reserva?.status == 'Canceled' &&
                    <div className="cancelado">Está reservación fue cancelada</div>
                }
                {(reserva?.status == 'CreatedSpacesPending' || reserva?.status == 'WaitingSpaces') &&
                    <div class='aviso'>El almacén no cuenta con los espacios solicitados, puedes crear una solicitud para que el Host libere los espacios requeridos</div>
                }
                <div className="gridBooking">
                    <div>
                        <div className="datosReserva">
                            <div className="divEstatus">
                                <span className={reserva?.status}>
                                    {estatus[reserva?.status]}
                                    <img src={imgEstatus[reserva?.status]}/>
                                </span>
                            </div>
                            <h1 className="detalles">Detalles de tu reservación</h1>
                            {(reserva?.status == 'Pending' || reserva?.status == 'Partial') && reserva?.paymentIntent?.next_action &&
                                <div className="etiqueta">
                                    <h4>Completa tu pago por:
                                        <h2>${formatoNumero(reserva.paymentIntent.next_action.display_bank_transfer_instructions.amount_remaining/100)} ({reserva.paymentIntent.next_action.display_bank_transfer_instructions.currency.toUpperCase()})</h2>
                                    </h4>
                                    <div className="completarPago">
                                        <div>
                                            <span>CLABE</span>
                                            <span>{reserva.paymentIntent.next_action.display_bank_transfer_instructions.financial_addresses[0].spei.clabe}</span>
                                            <span onClick={()=>copiar(reserva.paymentIntent.next_action.display_bank_transfer_instructions.financial_addresses[0].spei.clabe)}>
                                                <img src={Copiar}/>
                                            </span>
                                        </div>
                                        <div>
                                            <span>Beneficiario</span>
                                            <span>PalletCloud</span>
                                            <span onClick={()=>copiar('PalletCloud')}>
                                                <img src={Copiar}/>
                                            </span>
                                        </div>
                                        <div>
                                            <span>Referencia</span>
                                            <span>{reserva.paymentIntent.next_action.display_bank_transfer_instructions.reference}</span>
                                            <span onClick={()=>copiar(reserva.paymentIntent.next_action.display_bank_transfer_instructions.reference)}>
                                                <img src={Copiar}/>
                                            </span>
                                        </div>
                                        <div>
                                            <span>Nombre del Banco</span>
                                            <span>{reserva.paymentIntent.next_action.display_bank_transfer_instructions.financial_addresses[0].spei.bank_name}</span>
                                            <span onClick={()=>copiar(reserva.paymentIntent.next_action.display_bank_transfer_instructions.financial_addresses[0].spei.bank_name)}>
                                                <img src={Copiar}/>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            }
                            <div className="resumenRenta">
                                {reserva?.status == "Booked" &&
                                    <div>
                                        <span>

                                            <div><b>Ubicación</b></div>
                                            <div>
                                                {reserva?.street ? reserva.street+" " : ""}
                                                {reserva?.number ? reserva.number+", " : ""}
                                                {reserva?.zipCode ? reserva.zipCode+", " : ""}
                                                {reserva?.Town}, {reserva?.State}
                                            </div>
                                        </span>
                                    </div>
                                }
                                <div>
                                    <span>
                                        <h3>Fechas</h3>
                                        {fechaI && fechaF &&
                                            <div className="fechaReserva">Del <b>{formatoFechaTxt(fechaI)}</b> al <b>{formatoFechaTxt(fechaF)}</b></div>
                                        }
                                    </span>
                                    {(!pagar && editable) &&
                                        <button className="editar" onClick={()=>{
                                            setModalEditar('Fechas');
                                        }}>Editar</button>
                                    }
                                </div>
                                <div>
                                    <span>
                                        <div><b>Espacios</b></div>
                                        <div>
                                            {espacios} espacio{espacios > 1 ? "s" : ""}
                                        </div>
                                        <div className="medidas descAlmacen">
                                            <span>Ancho: {config.sistema == 'ingles' ? formatoNumero(reserva?.width*(3.2808399)/100)+'ft' : formatoNumero(reserva?.width/100)+'m'}</span>
                                            <span>Largo: {config.sistema == 'ingles' ? formatoNumero(reserva?.length*(3.2808399)/100)+'ft' : formatoNumero(reserva?.length/100)+'m'}</span>
                                            <span>Alto: {config.sistema == 'ingles' ? formatoNumero(reserva?.height*(3.2808399)/100)+'ft' : formatoNumero(reserva?.height/100)+'m'}</span>   
                                            <span>Capacidad de carga: {config.sistema == 'ingles' ? formatoNumero(reserva?.weight*(2.20462262)/100)+'lb' : formatoNumero(reserva?.weight/100)+'kg'}</span>
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="datosPagoContacto" data-tour="datos-pago-contacto">
                            <div className="datosCliente">
                                <h3>Contacto</h3>
                                <form onSubmit={(e) => e.preventDefault()}>
                                    <label data-tour="input-telefono">
                                        <input type="phone" ref={refPhone} required value={reserva?.phone} placeholder="" onChange={(e)=>{
                                            setReserva({...reserva, phone: e.target.value});
                                        }}/>
                                        <span>Teléfono</span>
                                    </label>
                                </form>
                                <div>
                                    <span>
                                        {perfiles?.length > 0 &&
                                            <form onSubmit={(e) => e.preventDefault()}>
                                                <h4>RFC</h4>
                                                <select data-tour="select-rfc" value={reserva?.rfc ? reserva.rfc : ''} onChange={(e)=>{
                                                    setReserva({...reserva, rfc: e.target.value});
                                                }}>
                                                    {perfiles?.map((perfil, index)=>{
                                                        console.log(perfil);
                                                        return(
                                                            <option disabled={!perfil?.statusPerfil} key={index} value={perfil?.rfc}>{perfil?.statusPerfil ? '' : "[Inactivo]"} {perfil?.rfc} - {perfil?.name}</option>
                                                        )
                                                    })
                                                }
                                                </select>
                                            </form>
                                        }
                                        {perfiles?.length == 0 &&
                                            <div className="errorRFC">
                                                <h4>RFC</h4>
                                                <div>
                                                    <span>No has registrado ningún perfil</span>
                                                    <button className="btn black" onClick={()=>{
                                                        setModalPerfil(true);
                                                    }}>Registrar</button>
                                                </div>
                                            </div>
                                        }
                                    </span>
                                </div>
                            </div>

                            {((reserva?.inmediate != 0 && reserva?.status != 'CreatedSpacesPending' && reserva?.status != 'WaitingSpaces' && reserva?.status != 'Booked' && reserva?.status != 'Partial') || reserva?.status == 'Approved') &&
                                <div className="datosPago">
                                    <h3>Transferencia Bancaria</h3>
                                    <div className="datosBanco" data-tour="datos-banco">
                                        <div onClick={(e)=>{
                                            copiarConAnimacion('1234568791123', e.currentTarget);
                                        }}>
                                            <span>CLABE</span>
                                            <span>1234568791123</span>
                                        </div>
                                        <div onClick={(e)=>{
                                            copiarConAnimacion('1234568791123', e.currentTarget);
                                        }}>
                                            <span>Referencia</span>
                                            <span>1234568791123</span>
                                        </div>
                                        <div onClick={(e)=>{
                                            copiarConAnimacion('Banamex', e.currentTarget);
                                        }}>
                                            <span>Banco</span>
                                            <span>Banamex</span>
                                        </div>
                                    </div>
                                    <button className="btn" onClick={()=>{
                                        setModalTransferencia(true);
                                    }}>Confirmar Transferencia</button>
                                </div>
                            }
                        </div>

                        <div className={pagar ? "datosCliente" : ""}>
                            {(!reserva?.inmediate && (reserva?.status == 'Created' || reserva?.status == 'CreatedSpacesPending')) &&
                                <button className="btn btnReservar" data-tour="btn-solicitar" onClick={()=>{
                                    if(user?.sub){
                                        if(validar() && window.confirm('Una vez creada la solicitud ya no podrá ser editada. ¿Deseas continuar?'))
                                            solicitarReservacion();
                                    }
                                    else{
                                        setModalLogin(true);
                                    }
                                }}>
                                    {cargando &&
                                        <img src={Cargando}/>
                                    }
                                    {!cargando &&
                                        <span>Solicitar Reservación</span>
                                    }
                                </button>
                            }
                        </div>
                    </div>
                    <div className="reservar">
                        <div>
                            <div className="resumenAlmacen">
                                {reserva?.Photos && reserva?.Photos[0] &&
                                    <div className="miniAlmacen">
                                        <img src={reserva?.Photos[0].url}/>
                                    </div>
                                }
                                <div>
                                    <div>
                                        <div className="nombreAlmacen">{reserva?.name}</div>
                                        <div className="ubicacionAlmacen">{reserva?.Town+", "+ reserva?.State}</div>
                                    </div>
                                    <div className="puntua" onClick={()=>setShowRatingsModal(true)}>
                                        <span className="puntuacionAlmacen">
                                            {avgRating ? (
                                                <>
                                                    {avgRating.toFixed(2)}
                                                    <StarsRow value={avgRating} size={15}/>
                                                </>
                                            ) : '—'}
                                        </span>
                                        <span className="comentariosAlmacen">{ratingsCount} calificaciones</span>
                                    </div>
                                </div>
                            </div>
                            {showRatingsModal && (
                                <RatingListModal idPost={reserva?.idPost} onClose={()=>setShowRatingsModal(false)} />
                            )}
                            <div className="resumenPrecio" data-tour="resumen-precio">
                                <h2>Detalles del precio</h2>
                                {fechaI &&
                                    <div className="intervalo">
                                        <div>
                                            <span>Del</span>
                                            <span>{formatoFechaTxt(fechaI)}</span>
                                        </div>
                                        {fechaF &&
                                        <>
                                            <div>
                                                <span>Hasta</span>
                                                <span>{formatoFechaTxt(fechaF)}</span>
                                            </div>
                                            <div className="subtotal first">
                                                <span>Subotal (MXN)</span>
                                                <span>${(costo || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} MXN</span>
                                            </div>
                                            
                                            {metodo == 'Tarjeta' &&
                                                <div>
                                                    <span>Comisión (3.6%)</span>
                                                    <span>${(costo*.036 || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} MXN</span>
                                                </div>
                                            }
                                            
                                            <div className="subtotal">
                                                <span>IVA (16%)</span>
                                                {metodo == 'Transferencia' &&
                                                    <span>${((costo || 0)*.16).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} MXN</span>
                                                }
                                                {metodo == 'Tarjeta' &&
                                                    <span>${((costo*.036 + costo*1 || 0)*.16).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} MXN</span>
                                                }
                                            </div>
                                            <div className="total">
                                                <span>Total (MXN)</span>
                                                {metodo == 'Transferencia' &&
                                                    <span>${((costo || 0)*1.16).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} MXN</span>
                                                }
                                                {metodo == 'Tarjeta' &&
                                                    <span>${((costo*.036 + costo*1 || 0)*1.16).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} MXN</span>
                                                }
                                            </div>
                                            {reserva?.period == "3" &&
                                                <>
                                                    <i className="diferido">Diferido en {reserva?.time} pagos mensuales</i>
                                                    <div className="mensualidad">
                                                        <span>Mensualidad</span>
                                                        <span>
                                                        {metodo == 'Transferencia' &&
                                                            <span>{reserva?.time} x ${((costo/reserva?.time || 0)*1.16).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} MXN</span>
                                                        }
                                                        {metodo == 'Tarjeta' &&
                                                            <span>{reserva?.time} x ${((costo/reserva?.time*.036 + costo*1 || 0)*1.16).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} MXN</span>
                                                        }
                                                        </span>
                                                    </div>

                                                </>
                                            }
                                        </>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                {false &&
                <div className="datosAlmacen">
                    <div>
                        {/* <h2 className="descripcionAlmacen">{reserva?.descripcion || "Descripción del almacén"}</h2> */}
                        <h2 className="ubicacionAlmacen">{reserva?.Town+", "+ reserva?.State}</h2>
                    </div>
                    <div className="reservar">
                        <div>
                            <div className="descAlmacen">{reserva.assignedSpaces} espacio{reserva.assignedSpaces == 1 ? "" : "s"} disponibles</div>
                            <div className="descAlmacen">{reserva.length/100}m x {reserva.width/100}m x {reserva.height/100}m</div>
                            <div className="periodo">
                                {reserva.TypeTime.includes("1") &&
                                    <span>
                                        <span>${(reserva?.day*1 || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} MXN</span>
                                        <span>Día</span>
                                    </span>
                                }
                                {reserva.TypeTime.includes("2") &&
                                    <span>
                                        <span>${(reserva?.week*1 || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} MXN</span>
                                        <span>Semana</span>
                                    </span>
                                }
                                {reserva.TypeTime.includes("3") &&
                                    <span>
                                        <span>${(reserva?.month*1 || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} MXN</span>
                                        <span>Mes</span>
                                    </span>
                                }
                                {reserva.TypeTime.includes("4") &&
                                    <span>
                                        <span>${(reserva?.year*1 || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} MXN</span>
                                        <span>Año</span>
                                    </span>
                                }
                            </div>
                            <form onSubmit={(e) => e.preventDefault()} className="resv">
                                <label>
                                    <input type="number" min={1} value={espacios} onChange={(e)=>{
                                        setEspacios(e.target.value);
                                    }} max={reserva?.assignedSpaces}/>
                                    <span>Cantidad de Espacios</span>
                                </label>
                                <label onClick={()=>{
                                    setCalendario(true);
                                    setCalendarioF(false);
                                }}>
                                    <input type="text" value={formatoFecha(fechaI)} readOnly={true}/>
                                    <span>Desde</span>
                                </label>
                                {fechaF &&
                                    <label onClick={()=>{
                                        setCalendario(false);
                                        setCalendarioF(true);
                                    }}>
                                        <input type="text" value={formatoFecha(fechaF)} readOnly={true}/>
                                        <span>Hasta</span>
                                    </label>
                                }
                                <label>
                                    <input type="number" min={1} value={dias} onChange={(e)=>{
                                        // setDias(e.target.value);
                                        console.log(e.target.value);
                                        setFechaF(new Date(fechaI.getTime()+86400000*(e.target.value-1)));
                                    }}/>
                                    <span>Días</span>
                                </label>

                                {calendario &&
                                    <Calendar className="calendario"
                                        defaultActiveStartDate={fechaI} 
                                        tileClassName={({date})=>{
                                            if(date.getTime() == (new Date("2024-05-24".split("-"))).getTime()){
                                                return "highlight";
                                                console.log(date.getTime() == (new Date("2024-05-24".split("-"))).getTime());
                                            }
                                        }}
                                        tileDisabled={
                                            ({date})=>{
                                                if(date.getTime() == (new Date("2024-05-24".split("-"))).getTime()){
                                                    return true;
                                                    console.log(date.getTime() == (new Date("2024-05-24".split("-"))).getTime());
                                                }
                                            }   
                                        }
                                        allowPartialRange={fechaF}
                                        value={[fechaI, fechaF]} 
                                        onChange={(value)=>{
                                            setFechaI(value[0]);
                                            if(fechaF > value[0]){
                                                setCalendario(false);
                                                return false;
                                            }
                                            else{
                                                setFechaF(value[0]);
                                            }
                                            if(value[1]){
                                                setFechaF(new Date(value[1].getFullYear(), value[1].getMonth(), value[1].getDate()));
                                                setCalendario(false);
                                            }
                                        }}
                                        selectRange={true}
                                        minDate={hoy}/>
                                }
                                {calendarioF &&
                                    <Calendar className="calendario"
                                        defaultActiveStartDate={fechaF} 
                                        tileClassName={(date)=>{

                                        }}
                                        value={[fechaI, fechaF]} 
                                        onChange={(value)=>{
                                            setFechaF(value);
                                            setCalendarioF(false);
                                        }}
                                        minDate={hoy}/>
                                }
                            </form>
                            {fechaI &&
                                <div className="intervalo">
                                    <div>
                                        <span>Del</span>
                                        <span>{formatoFechaTxt(fechaI)}</span>
                                    </div>
                                    {fechaF &&
                                    <>
                                        <div>
                                            <span>Hasta</span>
                                            <span>{formatoFechaTxt(fechaF)}</span>
                                        </div>
                                        <div className="total">
                                            <span>Total (MXN)</span>
                                            <span>${(costo || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} MXN</span>
                                        </div>
                                    </>
                                    }
                                </div>
                            }

                        </div>
                    </div>
                </div>
                }
            </div>
        </>
    )
}

const CheckoutForm = () => {
    const { id } = useParams();
    const stripe = useStripe();
    const elements = useElements();

    const [errorMessage, setErrorMessage] = useState(null);

    const handleSubmit = async (event) => {
        // We don't want to let default form submission happen here,
        // which would refresh the page.
        event.preventDefault();

        if (!stripe || !elements) {
        // Stripe.js hasn't yet loaded.
        // Make sure to disable form submission until Stripe.js has loaded.
        return;
        }

        const {error} = await stripe.confirmPayment({
        //`Elements` instance that was used to create the Payment Element
        elements,
        confirmParams: {
            return_url: appUrl+'completado/'+id,
        },
        });


        if (error) {
        // This point will only be reached if there is an immediate error when
        // confirming the payment. Show error to your customer (for example, payment
        // details incomplete)
        setErrorMessage(error.message);
        } else {
        // Your customer will be redirected to your `return_url`. For some payment
        // methods like iDEAL, your customer will be redirected to an intermediate
        // site first to authorize the payment, then redirected to the `return_url`.
        }
    };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      <button className="btn continuar" disabled={!stripe}>Continuar</button>
      {/* Show error message to your customers */}
      {errorMessage && <div>{errorMessage}</div>}
    </form>
  )
};

const Progreso = ({progreso, inmediate, status})=>{
    const pasos = inmediate && status != 'CreatedSpacesPending'
        ? [
            'Confirmar datos',
            status != 'ConfirmTransfer' ? 'Completar pago' : 'Esperando confirmación',
            'Reserva completa',
        ]
        : [
            'Confirmar datos',
            'Esperar aprobación',
            status != 'ConfirmTransfer' ? 'Completar pago' : 'Esperando confirmación',
            'Reserva completa',
        ];
    const pasoActual = Math.min(progreso, pasos.length - 1);
    const finalizada = status === 'Booked';

    return(
        <section className="progresoReserva" aria-label="Progreso de la reservación">
            <div className="progresoReserva__resumen">
                <div>
                    <span className="progresoReserva__eyebrow">Estado de tu reserva</span>
                    <strong>{pasos[pasoActual]}</strong>
                </div>
                <span className="progresoReserva__contador">Paso {pasoActual + 1} de {pasos.length}</span>
            </div>
            <div className="progresoReserva__flujo" role="list">
                {pasos.map((texto, index) => {
                    const estado = finalizada || index < pasoActual
                        ? 'completado'
                        : index === pasoActual
                            ? 'actual'
                            : 'pendiente';
                    return (
                        <React.Fragment key={texto}>
                            <Paso numero={index + 1} estado={estado} texto={texto}/>
                            {index < pasos.length - 1 &&
                                <span
                                    className={"progresoReserva__flecha" + (finalizada || index < pasoActual ? " completada" : "")}
                                    aria-hidden="true"
                                />
                            }
                        </React.Fragment>
                    );
                })}
            </div>
        </section>
    );
}

const Paso = ({texto, numero, estado})=>{
    return (
        <div className={`paso ${estado}`} role="listitem" aria-current={estado === 'actual' ? 'step' : undefined}>
            <div className="circulo">{estado === 'completado' ? '✓' : numero}</div>
            <div className="paso__texto">
                <span>{texto}</span>
                <small>{estado === 'completado' ? 'Completado' : estado === 'actual' ? 'En proceso' : 'Pendiente'}</small>
            </div>
        </div>
    )
}

export default Reservar;